  // src/pages/HomeVisitPage.jsx
  import React from "react";
  import { useNavigate } from "react-router-dom";
  import Header from "./Header";

  const HomeVisitPage = () => {
    const navigate = useNavigate();

    const handleBookAppointment = () => {
      navigate("/book-appointment?type=home-visit");
    };

    return (
      <>
        <Header hideBookButton={true} />

        {/* Hero Section */}

  <section className="relative w-full h-screen min-h-[600px] bg-gradient-to-b from-blue-100 to-white overflow-hidden">
    <img
      src="/homeVisit.jpg"
      alt="Home Consultation"
      className="absolute inset-0 w-full h-full object-cover brightness-75 saturate-110"
      loading="lazy"
    />
    {/* <div className="absolute inset-0 bg-gradient-to-r from-[#204080]/90 to-transparent"></div> */}

    <div className="relative flex flex-col justify-center h-full px-6 md:px-12 lg:px-20 text-white z-10">
      <div className="max-w-2xl">
        <h1 className="text-4xl md:text-4xl lg:text-7xl font-extrabold leading-tight drop-shadow-lg mb-6">
          Expert <span className="text-[#204080]">Care</span> <br /> Right at Your <span className="text-[#204080]">Home </span>
        </h1>
        <p className="text-lg md:text-xl mb-10 font-bold leading-relaxed drop-shadow-md">
          Bringing healthcare home in Visakhapatnam. Our expert team offers compassionate, personalized consultations to support your well-being—all in the comfort and safety of your own home.
        </p>

        <button
           onClick={() => navigate("/book-appointment?type=home-visit")}
          className="bg-[#204080] hover:bg-[#2E5AAC] transition shadow-xl rounded-full px-10 py-4 font-semibold text-lg text-white hover:shadow-2xl transform hover:-translate-y-1 focus:outline-none focus:ring-4 focus:ring-blue-300"
          aria-label="Book a Home Visit"
        >
          Book a Home Visit
        </button>
      </div>
    </div>
  </section>


        {/* Info Section: How it Works & Benefits */}
        <section className="bg-white">
          <div className="max-w-7xl mx-auto px-6 space-y-12"> {/* Reduced vertical spacing */}

            {/* How Home Visit Care Works Section */}
          <section className="py-16 bg-gradient-to-b from-teal-50 to-white">
    <div className="max-w-7xl mx-auto px-6 space-y-16">
      <section className="space-y-10">
        {/* Step 1 */}
        <div className="flex flex-col md:flex-row min-h-[280px] items-center">
          <div className="md:w-1/2 bg-[#204080] text-white flex items-center justify-center px-10 py-14">
            <div>
              <h3 className="text-3xl font-extrabold mb-4">1. Book Your Home Visit</h3>
              <p className="max-w-md text-lg leading-relaxed">
                Schedule a convenient date and time for a healthcare professional to visit you at home via our online portal or phone.
              </p>
            </div>
          </div>
          <div className="md:w-1/2 bg-white flex items-center justify-center p-6">
            <img
              src="./bhv.avif"
              alt="Patient scheduling appointment"
              className="rounded-lg shadow-lg w-full max-w-md object-cover"
              loading="lazy"
            />
          </div>
        </div>

        {/* Step 2 */}
        <div className="flex flex-col md:flex-row min-h-[280px] items-center">
          <div className="md:w-1/2 bg-white flex items-center justify-center p-6 order-last md:order-first">
            <img
              src="./dk.jpg"
              alt="Healthcare professional preparing equipment"
              className="rounded-lg shadow-lg w-full max-w-md object-cover"
              loading="lazy"
            />
          </div>
          <div className="md:w-1/2 bg-[#204080] text-white flex items-center justify-center px-10 py-14 order-first md:order-last">
            <div>
              <h3 className="text-3xl font-extrabold mb-4">2. Tailored Care Preparation</h3>
              <p className="max-w-md text-lg leading-relaxed">
                Our team reviews your health needs and prepares personalized care plans and necessary medical supplies for your home visit.
              </p>
            </div>
          </div>
        </div>

        {/* Step 3 */}
        <div className="flex flex-col md:flex-row min-h-[280px] items-center">
          <div className="md:w-1/2 bg-[#204080] text-white flex items-center justify-center px-10 py-14">
            <div>
              <h3 className="text-3xl font-extrabold mb-4">3. Receive Care at Home</h3>
              <p className="max-w-md text-lg leading-relaxed">
                Our healthcare professional arrives at your home to provide compassionate medical consultation and support, including follow-ups as needed.
              </p>
            </div>
          </div>
          <div className="md:w-1/2 bg-white flex items-center justify-center p-6">
            <img
              src="/rc.webp"
              alt="Healthcare provider with patient at home"
              className="rounded-lg shadow-lg w-full max-w-md object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </div>
  </section>


            {/* Measurable Benefits Section */}
            <section className="py-16 bg-gradient-to-br from-slate-50 via-blue-50 to-white"> {/* Reduced padding */}
              <div className="max-w-6xl mx-auto px-6 space-y-10"> {/* Reduced spacing */}
                <h2 className="text-4xl font-extrabold text-[#204080] text-center">
                  Measurable Benefits You Can See
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-10"> {/* Reduced gap */}
                  {/* Progress Circle 1 */}
                  <div className="flex flex-col items-center">
                    <svg className="w-32 h-32" viewBox="0 0 100 100">
                      <circle
                        cx="50"
                        cy="50"
                        r="45"
                        stroke="white"
                        strokeWidth="10"
                        fill="none"
                      />
                      <circle
                        cx="50"
                        cy="50"
                        r="45"
                        stroke="#204080"
                        strokeWidth="10"
                        fill="none"
                        strokeDasharray={283}
                        strokeDashoffset={283 * (1 - 0.7)}
                        strokeLinecap="round"
                        transform="rotate(-90 50 50)"
                      />
                      <text
                        x="50"
                        y="58"
                        textAnchor="middle"
                        fontSize="24"
                        fill="#204080"
                        fontWeight="bold"
                      >
                        70%
                      </text>
                    </svg>
                    <p className="mt-6 text-lg text-center text-gray-800 max-w-xs">
                      Reduction in infection risk compared to hospital visits.
                    </p>
                  </div>

                  {/* Progress Circle 2 */}
                  <div className="flex flex-col items-center">
                    <svg className="w-32 h-32" viewBox="0 0 100 100">
                      <circle
                        cx="50"
                        cy="50"
                        r="45"
                        stroke="white"
                        strokeWidth="10"
                        fill="none"
                      />
                      <circle
                        cx="50"
                        cy="50"
                        r="45"
                        stroke="#204080"
                        strokeWidth="10"
                        fill="none"
                        strokeDasharray={283}
                        strokeDashoffset={283 * (1 - 0.85)}
                        strokeLinecap="round"
                        transform="rotate(-90 50 50)"
                      />
                      <text
                        x="50"
                        y="58"
                        textAnchor="middle"
                        fontSize="24"
                        fill="#204080"
                        fontWeight="bold"
                      >
                        85%
                      </text>
                    </svg>
                    <p className="mt-6 text-lg text-center text-gray-800 max-w-xs">
                      Patient satisfaction rate with home visit care.
                    </p>
                  </div>

                  {/* Progress Circle 3 */}
                  <div className="flex flex-col items-center">
                    <svg className="w-32 h-32" viewBox="0 0 100 100">
                      <circle
                        cx="50"
                        cy="50"
                        r="45"
                        stroke="white"
                        strokeWidth="10"
                        fill="none"
                      />
                      <circle
                        cx="50"
                        cy="50"
                        r="45"
                        stroke="#204080"
                        strokeWidth="10"
                        fill="none"
                        strokeDasharray={283}
                        strokeDashoffset={283 * (1 - 0.9)}
                        strokeLinecap="round"
                        transform="rotate(-90 50 50)"
                      />
                      <text
                        x="50"
                        y="58"
                        textAnchor="middle"
                        fontSize="24"
                        fill="#204080"
                        fontWeight="bold"
                      >
                        90%
                      </text>
                    </svg>
                    <p className="mt-6 text-lg text-center text-gray-800 max-w-xs">
                      Patients showing health improvements within 30 days.
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>

        {/* Call to Action Section */}
        <section className="py-16 bg-gradient-to-r from-teal-600 to-teal-400 text-white text-center px-6">
          <div className="max-w-3xl mx-auto space-y-6">
            <h2 className="text-4xl font-extrabold">Ready for Safer, Smarter Healthcare?</h2>
            <p className="text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
              Book your home visit today and experience comfort, safety, and professional care — without stepping outside.
            </p>
            <button
            onClick={() => navigate("/book-appointment?type=home-visit")}
              className="mt-6 inline-block bg-white text-teal-700 font-bold rounded-full px-10 py-4 shadow-lg hover:shadow-xl transition transform hover:-translate-y-1"
              aria-label="Book your home visit appointment"
            >
              Book Your Visit
            </button>
          </div>
        </section>
      </>
    );
  };

  export default HomeVisitPage;
